export default __webpack_public_path__ + "static/media/2035.a2fa118c.png";